import isEmail from 'validator/lib/isEmail';
import { DateTime, Duration } from 'luxon';

import { LuxonFormats, ValidationValue, ValidationResult } from 'types';
import { TestContext, ValidationError } from 'yup';

export const required = (value: ValidationValue, errorMessage = 'Required'): ValidationResult =>
  value === '' || value === null || value === undefined || value === false
    ? errorMessage
    : undefined;

export const email = (
  value: ValidationValue,
  errorMessage = 'Invalid email address',
): ValidationResult => (value && !isEmail(String(value)) ? errorMessage : undefined);

export const isValidDateOfBirth = (
  testContext: TestContext,
  value?: ValidationValue,
): boolean | ValidationError => {
  let message: string;
  if (value) {
    const date = DateTime.fromFormat(String(value), LuxonFormats.UserFacingDob);
    if (!date.isValid) {
      message = 'Invalid date format. Please use MM/DD/YYYY';
    } else {
      const now = Date.now();
      if (date.toMillis() > now) {
        message = 'Date of birth can not be in future';
      } else if (Duration.fromMillis(now - date.toMillis()).as('years') > 200) {
        message = 'Date of birth is too far in the past';
      }
    }
  }
  if (message === undefined) return true;
  return testContext.createError({
    path: 'dob',
    message,
  });
};

export const dateOfBirth = (value: ValidationValue, errorMessage?: string): ValidationResult => {
  if (value) {
    const date = DateTime.fromFormat(String(value), LuxonFormats.UserFacingDob);

    if (!date.isValid) {
      return errorMessage || 'Invalid date format. Please use MM/DD/YYYY';
    }
    const now = Date.now();
    if (date.toMillis() > now) {
      return errorMessage || 'Date of birth can not be in future';
    }
    if (Duration.fromMillis(now - date.toMillis()).as('years') > 200) {
      return errorMessage || 'Date of birth is too far in the past';
    }
  }
  return undefined;
};

export const phoneRegexp = /(?:\+?\d\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/;

export const phone = (
  value: ValidationValue,
  errorMessage = 'Invalid phone number. Please use XXX-XXX-XXXX format',
): ValidationResult => (value && !phoneRegexp.test(String(value)) ? errorMessage : undefined);
